// removed by extract-text-webpack-plugin
module.exports = {"messageBox":"vRPUmfqvPwp-LJnJnqAxd","messageIcon":"rqdskhGx0UoD_EKuSWW91","title":"aL7FC3wJEkIwp1QYcorb9","messages":"_22kFY6AWg3J5Z5ca2LWZPj","overflow":"_1RNe-jWN0h01ITmq6XoyG0","item":"_6iNcQTQtkEwpFip7xTzXa","footer":"_1nz9nezH82EP9fs9xecIjr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BaseLayer.less
// module id = 379
// module chunks = 0